<template>
  <div id="Edit">
    <button @click="remove">삭제</button>
    <span class="line">|</span>
    <button @click="edit">수정</button>
  </div>
</template>

<script>

export default {
  name: 'Edit',
  props: ['question', 'answer'],
  components: {
  },
  data: function () {
    return {
    }
  },
  computed: {},
  created() {
  },
  destroyed() {},
  methods: {
    async remove() {
      if (this.question) {
        this.$emit('removeQuestion', this.question)
        let textarea = document.getElementById('TalkInput').getElementsByTagName('textarea')[0]
        textarea.focus()
      } else if (this.answer) {
        this.$emit('removeAnswer', this.answer)
        let textarea = document.getElementById('TalkInput').getElementsByTagName('textarea')[0]
        textarea.focus()
      }
    },
    edit() {
      if (this.question) {
        this.$emit('editQuestion', this.question)
        let textarea = document.getElementById('TalkInput').getElementsByTagName('textarea')[0]
        textarea.focus()
      } else if (this.answer) {
        this.$emit('editAnswer', this.answer)
        let textarea = document.getElementById('TalkInput').getElementsByTagName('textarea')[0]
        textarea.focus()
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  #Edit {
    font-size: 15px;
    line-height: 23px;
    color: #8a94a2;
    button {
      display: block;
      float: left;
      height: 23px;
      font-size: 15px;
      color: #8a94a2;
      background-color: initial;
    }
    .line {
      display: block;
      float: left;
      margin-left: 5px;
      margin-right: 5px;
    }
  }
</style>
